import { TABLE_DISTRIBUCION_POR_CONDICION } from '../../../../../config/tables'
import { COLUMNS_DISTRIBUCION_POR_CONDICION, COLUMNS_DISTRIBUCION_POR_CONDICION_TO_PRINT } from './constantesDistribucionPorCondicion'
import { TablaDistribucionPorCondicionService } from '../../../../../models/movimiento/cuadroDeMando/tabla_distribucion_por_condicion'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import React from 'react'
import { Button } from 'react-bootstrap'

export function actualizarDatosParaMuiTable (conLink) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_DISTRIBUCION_POR_CONDICION
    })
    const promiseTablaDistribucionPorCondicion = TablaDistribucionPorCondicionService.getDataTablaDistribucionPorCondicion()
    const promiseTablaDistribucionPorCondicionTotal = TablaDistribucionPorCondicionService.getTablaDistribucionPorCondicionTotal()
    Promise.all([promiseTablaDistribucionPorCondicion, promiseTablaDistribucionPorCondicionTotal]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = () => <> {pdfCustomToolbarGenerator(
        'Distribución Por Cereal',
        dataCombinada,
        COLUMNS_DISTRIBUCION_POR_CONDICION_TO_PRINT,
        'portrait')()}{conLink && <Button href='/laridae/movimiento/distribucionPorCondicion' class='btn btn-primary btn-lg active' role='button' aria-pressed='true'>Detalles Por Condición</Button>}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DISTRIBUCION_POR_CONDICION,
          data: dataCombinada,
          title: `Distribución Por Condición`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }

        },
        id: TABLE_DISTRIBUCION_POR_CONDICION
      })
    }
  }
}
